import { useEffect, type ReactNode } from 'react';

/**
 * ═══════════════════════════════════════════════════════════════════════
 * ВЫПАДЕНИЕ ПОД КНОПКОЙ — ОДНО УСТРОЙСТВО НА ВСЮ ШАПКУ.
 *
 * В шапке кабинета их три: кабинеты, профиль и выгрузка. Устроены они
 * в эталоне одинаково, и одинаково же должны закрываться — иначе
 * человек, привыкший гасить одно нажатием мимо, обнаружит, что второе
 * так не гаснет, и решит, что интерфейс сломался.
 *
 * ═══════════════════════════════════════════════════════════════════════
 * ЗАКРЫТИЕ — ПОДЛОЖКОЙ, А НЕ СЛУШАТЕЛЕМ НА `document`
 *
 * Так сделано в эталоне (`position:fixed;inset:0`, слой 55 — на один
 * ниже самого выпадения), и так правильнее:
 *
 *  ▸ слушатель на `document` ловит нажатие ПОСЛЕ того, как оно дошло
 *    до элемента под ним. Нажал по кнопке другого выпадения — первое
 *    закрылось, второе успело открыться и тут же закрылось само.
 *    Подложка съедает нажатие целиком: закрывается одно, второе
 *    открывается следующим нажатием, и это видно глазом;
 *
 *  ▸ слушатель приходится снимать в `useEffect`, и он переживает
 *    размонтирование, если ветку убрали в том же кадре.
 *
 * ЗАКРЫТИЕ ПО Escape ОСТАЁТСЯ СЛУШАТЕЛЕМ: у клавиатуры подложки нет.
 * ═══════════════════════════════════════════════════════════════════════
 */
export function Выпадение({
  открыто,
  закрыть,
  children,
}: {
  открыто: boolean;
  закрыть(): void;
  children: ReactNode;
}) {
  useEffect(() => {
    if (!открыто) return;
    const наКлавишу = (e: KeyboardEvent) => {
      if (e.key === 'Escape') закрыть();
    };
    window.addEventListener('keydown', наКлавишу);
    return () => window.removeEventListener('keydown', наКлавишу);
  }, [открыто, закрыть]);

  if (!открыто) return null;

  return (
    <>
      {/* Подложка не видна и ничего не значит для чтения с экрана:
          у клавиатуры для того же есть Escape, а лишняя кнопка в обходе
          по Tab — это остановка на пустом месте. */}
      <span aria-hidden="true" className="k-подложка-выпадения" onClick={закрыть} />
      {children}
    </>
  );
}
